import { render, staticRenderFns } from "./UpmoodBand.vue?vue&type=template&id=655c7f9a&scoped=true&"
import script from "./UpmoodBand.vue?vue&type=script&lang=js&"
export * from "./UpmoodBand.vue?vue&type=script&lang=js&"
import style0 from "./UpmoodBand.vue?vue&type=style&index=0&id=655c7f9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655c7f9a",
  null
  
)

export default component.exports